import { AuthProvider } from 'ra-core';
import { ROLE } from './utils.js';
let baseAuthUrl = process.env.REACT_APP_BASE_AUTH_URL;
let staffAppUrl = process.env.REACT_APP_BASE_STAFF_APP_URL;
// Set the current hostname for API url if there is no one in env configuration
if (!baseAuthUrl) {
    baseAuthUrl = window.location.protocol + '//' + window.location.hostname + ':1337';
}
const getToken  = () => {
        var token = '' as any;
        var tokenLocalStorage = localStorage.getItem("token"); 
        var tokenFromCookie = document.cookie.indexOf("token") !== -1 ? document.cookie.split(";")[0].split("=")[1] : '' ;
        if(tokenFromCookie && !tokenLocalStorage) {
            token = tokenFromCookie;
        }
        else if(tokenLocalStorage){
            token = tokenLocalStorage;
        }
        return token;
}

const authProvider: AuthProvider = {

    login: ({ username, password }) => {
        const options = {
            method: 'POST',
            body: JSON.stringify({ username, password }),
            headers: {
                'Content-Type': 'application/json'
            }
        }
        return fetch(`${baseAuthUrl}/login`, options)
            .then(response => {
                return response.json();
            })
            .then(json => {
                const {mobileApp} = json.data.user;

                if (!json.success) {
                    throw new Error('error');
                }
                else {
                    if(mobileApp === true || mobileApp === 1 ){
                       let host = window.location.hostname;
                       if(host === "localhost"){
                           document.cookie = 'token=' + json.data.token + '; path=/'
                       }
                       else {
                           document.cookie = 'token=' + json.data.token +'; path=/; domain='+host;
                       }
                       window.location.href = `${staffAppUrl}`;
                       return Promise.reject('Forwarding to Staff App');

                    }else{
                 
                        localStorage.setItem('token', json.data.token);
                        localStorage.setItem('change', json.data.user.forceChangePassword);
                        localStorage.setItem('id', json.data.user.id);
                        localStorage.setItem('userData', JSON.stringify(json.data));
                    }
                } 
            });
    },
    logout: () => {
        const options = {
            method: 'POST',
            body: JSON.stringify({
                token: localStorage.getItem('token')
            }),
            headers: {
                'Content-Type': 'application/json'
            }
        }
        return window.fetch(`${baseAuthUrl}/logout`, options)
            .then(response => {
                return response.json();
            })
            .then(json => {
                console.log(json)
                if (json.success) {
                    localStorage.removeItem('token');
                    localStorage.removeItem('categoryId');
                    localStorage.removeItem('selectedInfoPage');
                    return Promise.resolve();
                }
            });
    },
    checkError: (error) => {
        const status = error.status;
        if (status === 401 || status === 403) {
            localStorage.removeItem('token');
            return Promise.reject();
        }
        return Promise.resolve();
    },
    checkAuth: () => {
        const userID = localStorage.getItem('id')
        const change = localStorage.getItem('change')
        if (change === 'true') {
            // localStorage.removeItem('token');
            return window.fetch(`${baseAuthUrl}/users/gettokenresetpassword/${userID}`)
                .then(response => {
                    return response.json();
                })
                .then(json => {
                    console.log(json.data[0].token)
                    if (json.success) {
                        if (json.data.length > 0) {
                            return Promise.reject({ redirectTo: `/resetpassword/${json.data[0].token}` })
                        }
                        return Promise.resolve();
                    }
                });
        }
        const options = {
            method: 'POST',
            body: JSON.stringify({
                token: getToken(),
                type: 1
            }),
            headers: {
                'Content-Type': 'application/json'
            }
        }
        return window.fetch(`${baseAuthUrl}/check`, options)
            .then(response => {
                return response.json();
            })
            .then(json => {
                if (json.success) {
                    return Promise.resolve();
                }
                else
                    return Promise.reject({ redirectTo: '/login' })
            }).catch(() => {
                return Promise.reject({ redirectTo: '/login' })
            });

    },
    getPermissions: () => {

        var options = { method: 'GET' } as any
        options.headers = new Headers({ Accept: 'application/json' });
        options.headers.set('token', getToken());
        return fetch(`${baseAuthUrl}/users/getpermissionsbytoken`, options)
            .then(response => {
                return response.json();
            })
            .then(json => {
                if (json.success) {
                    //check role user (if staff and token valid href to staff app)
                    // if(json.data.user.mobileApp === 1 || json.data.user.mobileApp === true){
                    //     window.location.href = `${staffAppUrl}`;
                    //     return Promise.reject('Forwarding to Staff App');
                    // }else{
                    //     localStorage.setItem('userData', JSON.stringify(json.data));
                    //     const role = localStorage.getItem('userData');
                    //     return role ? Promise.resolve(JSON.parse(role).permission) : Promise.reject();
                    // }
                    localStorage.setItem('userData', JSON.stringify(json.data));
                    const role = localStorage.getItem('userData');
                    return role ? Promise.resolve(JSON.parse(role).permission) : Promise.reject();
                }
            })
            .catch((e: any) => {
                const role = localStorage.getItem('userData');
                return role ? Promise.resolve(JSON.parse(role).permission) : Promise.reject();
            });
    },

    /*
    Custom function for authProvider
     */
    /**
     * Forgot password
     * @param email: email
     */
    forgotPassword: (email: string) => {
        const resetPasswordLink = window.location.protocol + '//' + window.location.hostname + ':' + window.location.port + '/#/resetpassword';

        const options = {
            method: 'POST',
            body: JSON.stringify({
                email: email,
                host: resetPasswordLink,
            }),
            headers: {
                'Content-Type': 'application/json'
            }
        };
        return fetch(`${baseAuthUrl}/forgot`, options)
            .then(response => {
                return response.json();
            })
            .catch((e) => {
                return Promise.reject();
            });
    },

    checkResetPasswordToken: (token: string) => {
        const options = {
            method: 'POST',
            body: JSON.stringify({
                token: token,
                type: 2
            }),
            headers: {
                'Content-Type': 'application/json'
            }
        };
        return fetch(`${baseAuthUrl}/check`, options)
            .then(response => {
                return response.json();
            })
            .catch((e: any) => {
                return Promise.reject();
            });
    },

    resetFunctionAction: () => {
        var options = { method: 'GET' } as any
        options.headers = new Headers({ Accept: 'application/json' });
        options.headers.set('token', localStorage.getItem('token'));
        return fetch(`${baseAuthUrl}/users/getpermissionsbytoken`, options)
            .then(response => {
                return response.json();
            })
            .then(json => {
                if (json.success) {
                    localStorage.setItem('userData', JSON.stringify(json.data));
                }
            })
            .catch((e: any) => {
                return Promise.reject();
            });
    },

    resetPassword: (data: any) => {
        const options = {
            method: 'POST',
            body: JSON.stringify(data),
            headers: {
                'Content-Type': 'application/json'
            }
        };

        return fetch(`${baseAuthUrl}/reset`, options)
            .then(response => {
                return response.json();
            }).catch(() => {
                return Promise.reject();
            });
    }
};

export { baseAuthUrl };

export default authProvider;
